import useSession from 'components/auth/useSession'

export const useAcessoLotacao = () => {
  const { data } = useSession()

  if (data.acesso.__typename === 'Lotacao') {
    return data.acesso
  }

  return null
}
